import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import Flex from "../../Generic/Flex";

export default function CareMomentsIntroInstructionsCard() {
  return (
    <AppCard>
      <AppCardContent>
        <Heading>{translate(STRINGS.JOIN_NOW_TO_GET_THIS_LIMITED_TIME_BENEFIT)}</Heading>
        <Flex direction="column" gap={12}>
          <AppCard>
            <AppCardContent>
              <Flex gap={16} alignItems="center">
                <StepImage src="/assets/3d-ramp-trophy.jpg" />
                <StepDescription>
                  {translate(STRINGS.CLIMB_THE_RANKS_BY_COMPLETING_VISITS)}
                </StepDescription>
              </Flex>
            </AppCardContent>
          </AppCard>

          <AppCard>
            <AppCardContent>
              <Flex gap={16} alignItems="center">
                <StepImage src="/assets/3d-eco-coins.jpg" />
                <StepDescription>
                  {translate(STRINGS.EARN_MORE_HIGHER_RANKS_MEANS_HIGHER_PAY)}
                </StepDescription>
              </Flex>
            </AppCardContent>
          </AppCard>

          <AppCard>
            <AppCardContent>
              <Flex gap={16} alignItems="center">
                <StepImage src="/assets/3d-graph-up.jpg" />
                <StepDescription>
                  {translate(STRINGS.AVOID_MISSED_VISITS_TO_KEEP_YOUR_RANK)}
                </StepDescription>
              </Flex>
            </AppCardContent>
          </AppCard>
        </Flex>
      </AppCardContent>
    </AppCard>
  );
}

const Heading = styled.h3`
  margin: 0 0 16px;
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  padding: 8px;
`;

const StepImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 8px;
`;

const StepDescription = styled.p`
  margin: 0;
  color: var(--tw-slate-900);
`;
